// removed by extract-text-webpack-plugin
module.exports = {"followButton":"followButton---3h4Zd"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/FollowButton/style.styl
// module id = hk2c
// module chunks = 89